import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { globals } from '@app/config/globals';
import { POSITION_LIST } from '@app/config/position.data';
import { GenericFormComponent } from '@app/helpers/generic-form-component';
import { ConstantsService } from '@app/services/constants.service';
import { EmployeeService } from '@app/services/employee.service';
import { HelpService } from '@app/services/help.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';

@Component({
  selector: 'form-employee-reference',
  templateUrl: './form-employee-reference.component.html',
  styleUrls: ['./form-employee-reference.component.css']
})
export class FormEmployeeReferenceComponent extends GenericFormComponent {


  @Output() eventSaveRecord = new EventEmitter<any>();
  @Input() sufix: string = '';

  public POSITION_LIST = POSITION_LIST.map(e => { return { id: e.text, text: e.text } });

  public _id = 0;
  public currentRecord: any = {};

  constructor(private employeeService: EmployeeService, private userService: UserService, public helpService: HelpService, public constantsService: ConstantsService) {
    super();
    this.createFormGroup();
  }

  createFormGroup() {

    this._formGroup = new UntypedFormGroup({
      referenceName: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
      referencePosition: new UntypedFormControl('', [Validators.required]),
      referenceInstitution: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
      referencePhoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(globals.pattern.phone_8digits)]),
      referenceEmail: new UntypedFormControl('', [Validators.required, Validators.pattern(globals.pattern.email)]),
    });
  }


  addReference(event: any) {

    event.preventDefault();

    this._formGroup.markAllAsTouched();

    if (this._formGroup.invalid) return;

    let req = {
      _idEmployee: this.userService.getIdEmployee(),
      referenceName: this.referenceName.value,
      referencePosition: this.referencePosition.value,
      referenceInstitution: this.referenceInstitution.value,
      referencePhoneNumber: '+569' + this.referencePhoneNumber.value,
      referenceEmail: this.referenceEmail.value
    };

    this.isLoadingRequest = true;

    this.employeeService.saveReference(this._id, req).toPromise().then(res => {

      this.isLoadingRequest = false;

      if (res?.status_code !== status_code.success) {
        return;
      }

      if (this._id === 0) {
        this._id = res._id;
      }
      else {
        this.currentRecord.referenceName = this.referenceName.value;
        this.currentRecord.referencePosition = this.referencePosition.value;
        this.currentRecord.referenceInstitution = this.referenceInstitution.value;
        this.currentRecord.referencePhoneNumber = '+569' + this.referencePhoneNumber.value;
        this.currentRecord.referenceEmail = this.referenceEmail.value
      }

      this.eventSaveRecord.next(null);
    },
      err => {

        this.isLoadingRequest = false;
        
        console.error(err);
      }
    );
  }

  reserValues() {

    this.currentRecord = {};
    this.referenceName.setValue('');
    this.referencePosition.setValue('');
    this.referenceInstitution.setValue('');
    this.referencePhoneNumber.setValue('');
    this.referenceEmail.setValue('');
  }



  get referenceName() { return this._formGroup.get('referenceName') as UntypedFormControl };
  get referencePosition() { return this._formGroup.get('referencePosition') as UntypedFormControl };
  get referenceInstitution() { return this._formGroup.get('referenceInstitution') as UntypedFormControl };
  get referencePhoneNumber() { return this._formGroup.get('referencePhoneNumber') as UntypedFormControl };
  get referenceEmail() { return this._formGroup.get('referenceEmail') as UntypedFormControl };
}